/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicareAssessmentForm } from './MedicareAssessmentForm';
import {
    MedicareAssessmentFormFromJSON,
    MedicareAssessmentFormFromJSONTyped,
    MedicareAssessmentFormToJSON,
    MedicareAssessmentFormToJSONTyped,
} from './MedicareAssessmentForm';

/**
 * 
 * @export
 * @interface GetLeadAssessmentForm200Response
 */
export interface GetLeadAssessmentForm200Response {
    /**
     * 
     */
    data?: MedicareAssessmentForm;
}

/**
 * Check if a given object implements the GetLeadAssessmentForm200Response interface.
 */
export function instanceOfGetLeadAssessmentForm200Response(value: object): value is GetLeadAssessmentForm200Response {
    return true;
}

export function GetLeadAssessmentForm200ResponseFromJSON(json: any): GetLeadAssessmentForm200Response {
    return GetLeadAssessmentForm200ResponseFromJSONTyped(json, false);
}

export function GetLeadAssessmentForm200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadAssessmentForm200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : MedicareAssessmentFormFromJSON(json['data']),
    };
}

export function GetLeadAssessmentForm200ResponseToJSON(json: any): GetLeadAssessmentForm200Response {
    return GetLeadAssessmentForm200ResponseToJSONTyped(json, false);
}

export function GetLeadAssessmentForm200ResponseToJSONTyped(value?: GetLeadAssessmentForm200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MedicareAssessmentFormToJSON(value['data']),
    };
}

